import { render, staticRenderFns } from "./PendingInvitations.vue?vue&type=template&id=766bdb2f&scoped=true"
import script from "./PendingInvitations.vue?vue&type=script&lang=js"
export * from "./PendingInvitations.vue?vue&type=script&lang=js"
import style0 from "./PendingInvitations.vue?vue&type=style&index=0&id=766bdb2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766bdb2f",
  null
  
)

export default component.exports